export const steps = {
  storage: [
    { element: '.storage-content', popover: { title: 'Интерфейс медиахранилища', description: 'Ваши папки и загруженные файлы хранятся здесь' } },
    { element: '.actions', popover: { title: 'Действия', description: 'Действия сверху доступны постоянно, действия снизу – зависят от выбранного файла' } },
    { element: '.stats-block', popover: { title: 'Статистика', description: 'Контролируйте заполненность медиахранилища и кол-во минут транскодирования, потраченных в этом месяце' } },
    { element: '.search-field', popover: { title: 'Поиск', description: 'Поиск файлов в медиахранилище по названию или описанию' } },
    { element: '.pull-right', popover: { title: 'Загрузка', description: 'Нажмите здесь для загрузки файлов в медиахранилище' } }
  ],
  s3: [
    { element: '.content-box', popover: { title: 'Интерфейс S3 хранилища', description: 'Здесь отображаются ваши бакеты и загруженные объекты' } },
    { element: '.profile-menu', popover: { title: 'Идентификаторы', description: 'ID вашего пользователя и аккаунта' } },
    { element: '.actions', popover: { title: 'Действия', description: 'Возможные действия с выбранными бакетами или объектами' } },
    { element: '.stats-block', popover: { title: 'Статистика', description: 'Контролируйте заполненность S3 хранилища' } },
    { element: '.search-field', popover: { title: 'Поиск', description: 'Поиск объектов в выбранном бакете' } }
  ],
  dns: [
    { element: '.dns-page', popover: { title: 'Зоны DNS', description: 'Список зон DNS' } },
    { element: '.actions', popover: { title: 'Действия', description: 'Управление зонами DNS' } },
    { element: '.search-field', popover: { title: 'Поиск', description: 'Поиск зоны по названию' } },
    { element: '.pull-right', popover: { title: 'Добавление', description: 'Добавить зону DNS' } }
  ],
  streams: [
    { element: '.streams-page', popover: { title: 'Потоки', description: 'Список записей видеопотоков' } },
    { element: '.actions', popover: { title: 'Действия', description: 'Возможные операции над выбранными потоками' } },
    { element: '.stats-block', popover: { title: 'Статистика', description: 'Контролируйте заполненность медиахранилища и кол-во минут транскодирования, потраченных в этом месяце' } },
    { element: '.search-field', popover: { title: 'Поиск', description: 'Фильтр по потокам' } },
    { element: '.pull-right', popover: { title: 'Добавление', description: 'Нажмите здесь для добавления потока' } }
  ],
  channels: [
    { element: '.channels-page', popover: { title: 'Вещание', description: 'Список каналов вещания' } },
    { element: '.actions', popover: { title: 'Действия', description: 'Возможные операции над выбранными каналами' } },
    { element: '.search-field', popover: { title: 'Поиск', description: 'Фильтр по потокам' } },
    { element: '.pull-right', popover: { title: 'Добавление', description: 'Нажмите здесь для создания канала' } }
  ],
  tasks: [
    { element: '.content-box', popover: { title: 'Задачи', description: 'Список задач по выбранным сортировкам' } },
    { element: '.actions', popover: { title: 'Действия', description: 'Действия над выбранными задачами' } }
  ],
  'cdn-stats': [
    { element: '.cdn-stats-page__select', popover: { title: 'Статистика', description: 'Выбор аккаунта' } },
    { element: '.cdn-stats-chart', popover: { title: 'Графики', description: 'Статистика по трафику' } },
    { element: '.cdn-stats-page__mini-charts', popover: { title: 'Диаграмы', description: 'Диаграмы посещения по хостам, браузерам, платформам и географии' } },
    { element: '.cdn-stats-actions-datepicker', popover: { title: 'Выбор периода', description: 'Временной период отображения статистики' } }
  ],
  settings: [
    {
      element: '[data-onboarding="tab-profile"]',
      popover: {
        title: 'Профиль',
        description: 'Здесь вы можете изменить личные данные'
      }
    },
    {
      element: '[data-onboarding="tab-auto"]',
      popover: {
        title: 'Автоматическая обработка файлов',
        description: 'Настройка автоматической обработки файлов при загрузке'
      }
    },
    {
      element: '[data-onboarding="tab-s3"]',
      popover: {
        title: 'Доступы S3',
        description: 'Генерация ключей S3 ID и S3 Key'
      }
    },
    {
      element: '[data-onboarding="tab-iam"]',
      popover: {
        title: 'IAM',
        description: 'Управление пользователями и ролями'
      }
    },
    {
      element: '[data-onboarding="tab-brands"]',
      popover: {
        title: 'Брендирование',
        description: 'Создание и изменение шаблонов внешнего вида плеера'
      }
    }
  ],
  'users-edit': [
    {
      element: '[data-onboarding="tab-user"]',
      popover: {
        title: 'Пользователь',
        description: 'Данные профиля пользователя '
      }
    },
    {
      element: '[data-onboarding="tab-settings"]',
      popover: {
        title: 'Доступы',
        description: 'Список сервисов к которым у пользователя будет доступ'
      }
    },
    {
      element: '[data-onboarding="tab-other"]',
      popover: {
        title: 'Дополнительно',
        description: 'Назначение пользователю дополнительных политик, добавление его в группу или выдача ему роли'
      }
    }
  ],
  'groups-edit': [
    {
      element: '[data-onboarding="tab-name"]',
      popover: {
        title: 'Группы',
        description: 'Название группы'
      }
    },
    {
      element: '[data-onboarding="tab-users"]',
      popover: {
        title: 'Группы',
        description: 'Пользователи, входящие в данную группу'
      }
    },
    {
      element: '[data-onboarding="tab-roles"]',
      popover: {
        title: 'Группы',
        description: 'Привязанные к группе роли'
      }
    }
  ],
  'roles-edit': [
    {
      element: '[data-onboarding="tab-name"]',
      popover: {
        title: 'Роли',
        description: 'Название роли'
      }
    },
    {
      element: '[data-onboarding="tab-users"]',
      popover: {
        title: 'Роли',
        description: 'Пользователи, которым выдана данная роль'
      }
    },
    {
      element: '[data-onboarding="tab-group"]',
      popover: {
        title: 'Роли',
        description: 'Группы, привязанные к данной роли'
      }
    }
  ],
  'policies-edit': [
    {
      element: '[data-onboarding="tab-name"]',
      popover: {
        title: 'Политика',
        description: 'Название политики'
      }
    },
    {
      element: '[data-onboarding="tab-whu"]',
      popover: {
        title: 'Политика',
        description: 'Пользователи, группы и роли, которым назначена данная политика'
      }
    },
    {
      element: '[data-onboarding="tab-table"]',
      popover: {
        title: 'Политика',
        description: 'Правила, которые содержит данная политика'
      }
    }
  ]
}
